var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 20,
    viewBox: "0 0 335 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 150.5,
    height: 2,
    rx: 1,
    fill: "#A5A6BB",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.562 9.56025C167.562 10.5083 167.389 11.3234 167.042 12.0056C166.695 12.6848 166.22 13.208 165.616 13.5751C165.014 13.9393 164.331 14.1214 163.565 14.1214C162.796 14.1214 162.109 13.9393 161.505 13.5751C160.904 13.208 160.43 12.6834 160.083 12.0012C159.736 11.3191 159.563 10.5054 159.563 9.56025C159.563 8.61218 159.736 7.79852 160.083 7.11926C160.43 6.43711 160.904 5.91394 161.505 5.54974C162.109 5.18265 162.796 4.99911 163.565 4.99911C164.331 4.99911 165.014 5.18265 165.616 5.54974C166.22 5.91394 166.695 6.43711 167.042 7.11926C167.389 7.79852 167.562 8.61218 167.562 9.56025ZM166.236 9.56025C166.236 8.83764 166.119 8.2292 165.884 7.73493C165.653 7.23777 165.335 6.86201 164.931 6.60765C164.529 6.3504 164.074 6.22177 163.565 6.22177C163.053 6.22177 162.597 6.3504 162.195 6.60765C161.793 6.86201 161.475 7.23777 161.241 7.73493C161.01 8.2292 160.894 8.83764 160.894 9.56025C160.894 10.2829 161.01 10.8928 161.241 11.3899C161.475 11.8842 161.793 12.2599 162.195 12.5172C162.597 12.7716 163.053 12.8987 163.565 12.8987C164.074 12.8987 164.529 12.7716 164.931 12.5172C165.335 12.2599 165.653 11.8842 165.884 11.3899C166.119 10.8928 166.236 10.2829 166.236 9.56025ZM169.233 14V5.12051H172.398C173.086 5.12051 173.656 5.23902 174.11 5.47603C174.567 5.71305 174.908 6.04112 175.134 6.46024C175.359 6.87646 175.472 7.35772 175.472 7.90402C175.472 8.44743 175.358 8.9258 175.129 9.33913C174.904 9.74958 174.563 10.069 174.106 10.2973C173.652 10.5257 173.081 10.6398 172.393 10.6398H169.996V9.48655H172.272C172.706 9.48655 173.058 9.4244 173.33 9.30011C173.604 9.17582 173.805 8.99517 173.933 8.75815C174.06 8.52113 174.123 8.23642 174.123 7.90402C174.123 7.56873 174.058 7.27824 173.928 7.03255C173.801 6.78686 173.6 6.59898 173.326 6.46891C173.054 6.33595 172.697 6.26947 172.255 6.26947H170.572V14H169.233ZM173.616 9.99382L175.81 14H174.284L172.133 9.99382H173.616Z",
    fill: "#8A8BAA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 184.5,
    y: 9,
    width: 150.5,
    height: 2,
    rx: 1,
    fill: "#A5A6BB",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOr);
export default __webpack_public_path__ + "static/media/Or.a9bb1991b96c23cdfb22ad0a5a4abd96.svg";
export { ForwardRef as ReactComponent };